import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import { ThemeProvider } from "@emotion/react";
import { appTheme } from "./Components/CstmTheme/Theme";
import { CssBaseline } from "@mui/material";
import AlertPopUp from "Components/AlertPopUp";
import OverlayLoader from "Components/OverlayLoader";

const App = () => {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <OverlayLoader />
      <AlertPopUp />
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
